import React from 'react';
import { CGNav } from './CGNav';
import { useGetUserAuthenticated } from 'common/react/hooks/use-get-user-authenticated';

export const CGFiltersAuthWrapper = (data) => {
    const { userAuthenticated } = useGetUserAuthenticated();

    return userAuthenticated !== null ? (
        <div className="stats-section-wrapper wrapper pb-8 mb-0">
            <CGNav {...data} userAuthenticated={userAuthenticated} />
        </div>
    ) : null;
};
